import { render, staticRenderFns } from "./PurchaseLicense.vue?vue&type=template&id=0bfd1586&scoped=true"
import script from "./PurchaseLicense.vue?vue&type=script&lang=js"
export * from "./PurchaseLicense.vue?vue&type=script&lang=js"
import style0 from "./PurchaseLicense.vue?vue&type=style&index=0&id=0bfd1586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd1586",
  null
  
)

export default component.exports